<template>
  <div class="copywriting">
    <div class="top-row">
      <p class="tips">
        <i class="el-icon-info"></i>
        <span>只有团队队长才能进行路演的管理操作</span>
      </p>
      <div class="btns">
        <el-button
          type="danger"
          size="medium"
          icon="el-icon-delete"
          :disabled="selectedIds.length == 0 || !isCaptain"
          @click="handleRemove()"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          @click="show = true"
          :disabled="!isCaptain"
          >视频添加入口</el-button
        >
      </div>
    </div>

    <el-table
      :data="list"
      @selection-change="handleSelectionChange"
      stripe
      class="list"
    >
      <el-table-column align="center" type="selection" width="55" />
      <el-table-column prop="name" label="文件名"> </el-table-column>
      <el-table-column
        prop="createTime"
        label="上传时间"
        width="200"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" size="small">
            <a :href="row.url" :download="row.name" target="_blank">下载</a>
          </el-button>
          <el-button
            v-if="isCaptain"
            size="mini"
            type="text"
            style="color: #f56c6c"
            @click="handleRemove(row.lyId)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      classv="template-dialog"
      title="上传路演文件"
      :visible.sync="show"
      width="35%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="80px"
        size="small"
      >
        <el-form-item label="文件名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="上传文件" prop="url" style="text-align: left">
          <uploadFile
            @success="uploadSuccess"
            :fileType="fileType"
            style="display: inline-block"
          >
            <div class="uploader">
              <i class="el-icon-document" v-if="form.url"></i>
              <i class="el-icon-plus" v-else></i>
            </div>
          </uploadFile>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleAdd"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { myRoadshow, save, del } from "@/api/projectPractice/roadshow";
import uploadFile from "@/components/uploadFile";

export default {
  components: {
    uploadFile,
  },
  data() {
    return {
      isCaptain: false,
      list: [],
      selectedIds: [],
      form: {
        name: "",
        url: "",
      },
      rules: {
        name: { required: true, message: "请输入文件名称", trigger: "blur" },
        url: { required: true, message: "请上传文件", trigger: "blur" },
      },
      fileType: [],
      show: false,
    };
  },
  created() {
    this.getList();
  },
  watch: {
    show(val) {
      if (!val) this.form = this.$options.data().form;
    },
  },
  methods: {
    getList() {
      this.$loading.show();
      myRoadshow({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data.list;
          this.isCaptain = res.data.isCaptain;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    uploadSuccess(file) {
      this.form.url = file.url;
      this.$refs.form.clearValidate("url");
    },
    handleAdd() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.classId = this.$route.query.id;
          save(this.form).then((res) => {
            if (res.code == 0) {
              this.getList();
              this.show = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.itemId);
    },
    // 删除
    handleRemove(lyId) {
      this.$msgbox({
        title: "提示",
        message: "您确定要删除该路演？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            del(lyId || this.selectedIds)
              .then(() => {
                this.$message.success("删除成功");
                this.getList();
              })
              .finally(() => {
                done();
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.copywriting {
  .top-row {
    margin-bottom: 10px;
    line-height: 36px;
    overflow: hidden;
    .tips {
      float: left;
      color: #f56c6c;
      i {
        margin-right: 5px;
      }
    }
    .btns {
      float: right;
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
  .uploader {
    width: 104px;
    height: 104px;
    line-height: 104px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #409eff;
    }

    .el-icon-plus {
      font-size: 28px;
      color: #8c939d;
      width: 104px;
      height: 104px;
      line-height: 104px;
      text-align: center;
    }
    .el-icon-document {
      font-size: 30px;
    }
  }
}
</style>